import GlobalModal from "../AlertModal/GlobalModal";


export function mapLoadingToResults(searchResults, selectedCharity, matchKey) {
  return searchResults.map(obj => {
    if (obj[matchKey] === selectedCharity[matchKey]) {
      return {
        ...obj,
        loading: true
      }
    }
    return { ...obj };
  });
}

export function mapLoadingCancelToResults(searchResults, selectedCharity, matchKey) {
  return searchResults.map(obj => {
    if (obj[matchKey] === selectedCharity[matchKey]) {
      return {
        ...obj,
        loading: false
      }
    }
    return { ...obj };
  });
}

// bugfix 6165 - redirect to directory listing of guidestar with app key to provide premier experience
// to vanguard customers
function createGuideStarLink(ein) {
  // GuideStar app key will be different as per environment so pull it from environment variables
  const guidestarAppKey = process.env.REACT_APP_GUIDESTAR_APP_KEY;
  return `https://nonprofitdirectory.guidestar.org/profile/${ein}/${guidestarAppKey}`;
}

export function handleGuideStarRedirect(ein) {
  const link = createGuideStarLink(ein);

  GlobalModal({handleOk:()=>{ window.open(link, "_blank")},contents:"A Guidestar profile for the organization you selected will open in a new page. If you want to recommend a grant to this organization, please return to this Vanguard Charitable page to get started.",type:"confirm"
})
  
}

export function removeNtee(val){
    val=val.split(" ")
  let updatedArr = [];
  val.forEach(item => {
     let matches = item.match(/\d+/g);
  if (matches !== null) {
  }
  else{
    updatedArr.push(item)
   }
  })
  updatedArr=updatedArr.join(" ")
  return updatedArr
  }

  export function sortLegalName(val){
    function dynamicSort(property) {
      let sortOrder = 1;
  
      if(property[0] === "-") {
          sortOrder = -1;
          property = property.substr(1);
      }
  
      return function (a,b) {
          if(sortOrder === -1){
              return b[property].localeCompare(a[property]);
          }else{
              return a[property].localeCompare(b[property]);
          }        
      }
  }
  val.sort(dynamicSort("charityName"));
  return val
  }